export const VECTORS = {
  // Airborne and similiar vectors
  AIRBORNE: "Airborne",
  DROPLET: "Airborne (Droplet)", 
  AIRBORNE_SPORES: "Airborne (Spores)",
  RESPIRATORY_DROPLETS: "Airborne (Respiratory droplets)",
  // Insect vectors
  MOSQUITO: "Insect (Mosquito)",
  TICK: "Insect (Tick)",
  SANDFLY: "Insect (Sandfly)",
  FLEA_BITE: "Insect (Flea)",
  TRIATOMINE_BUG: "Insect (Triatomine bug)",
  TSETSE_FLY: "Insect (Tsetse fly)",
  // Other vectors
  ANIMAL_BITE: "Animal bite",
  FECAL_ORAL: "Fecal-oral",
  BLOOD: "Blood",
  WOUND_CONTAMINATION: "Wound contamination",
  BODY_FLUIDS: "Body fluids",
  ENDOGENOUS: "Endogenous",
  DIRECT_CONTACT: "Direct contact",
  FRESHWATER_SNAILS: "Freshwater snails",
  CONTAMINATED_FOOD: "Contaminated food",
  CONTAMINATED_WATER: "Polluted water",
  CAT_FECES_UNDERCOOKED_MEAT: "Cat feces/Undercooked meat",
  ANIMAL_URINE: "AnimaI urine", // Capital i so that it doesn't partially match "animal bite"
  SOIL_BIRD_DROPPINGS: "Soil/Bird droppings",
  WATERBORNE: "Waterborne",
  SALIVA: "Saliva",
  UNDERCOOKED_MEAT: "Undercooked meat",
};

export const ETIOLOGY = {
  VIRUS: "Virus",
  BACTERIA: "Bacteria", 
  PROTOZOA: "Protozoa",
  FUNGUS: "Fungus",
  PARASITE: "Parasite"
};

export const VACCINE_AVAILABILITY = {
  NO: "No",
  YES: "Yes",
  LIMITED: "Yes (limited)"
};

export const TREATMENTS = {
  // Antibiotics
  DOXYCYCLINE: "Antibiotics (Doxycycline)",
  CEFTRIAXONE_AZITHROMYCIN: "Antibiotics (Ceftriaxone/Azithromycin)",
  ANTIBIOTICS_MACROLIDES: "Antibiotics (macrolides, TMP-SMX)",
  IV_ANTIBIOTICS_STEROIDS: "Antibiotics (IV) + steroids",
  CIPROFLOXACIN_DOXYCYCLINE: "Antibiotics (Ciprofloxacin/Doxycycline)",
  STREPTOMYCIN_GENTAMICIN: "Antibiotics (Streptomycin/Gentamicin)",
  PENICILLIN_DOXYCYCLINE: "Antibiotics (Penicillin/Doxycycline)",
  IMMUNOGLOBULIN_ANTIBIOTICS: "Antibiotics (metronidazole) + immunoglobulin",
  ANTITOXIN_ANTIBIOTICS: "Antibiotics + antitoxin",
  METRONIDAZOLE: "Antibiotics (Metronidazole)",
  SULFADIAZINE_PYRIMETHAMINE: "Antibiotics (Sulfadiazine + Pyrimethamine)",
  ATOVAQUONE_AZITHROMYCIN: "Antibiotics (Atovaquone + Azithromycin)",
  PENICILLIN_G: "Antibiotics (Penicillin G)",
  LEVOFLOXACIN_AZITHROMYCIN: "Antibiotics (Levofloxacin/Azithromycin)",
  BOTULINUM_ANTITOXIN: "Antitoxin + supportive care / antibiotics",
  TOPICAL_ANTIFUNGALS: "Antifungals (topical terbinafine/clotrimazole)",
  FEXINIDAZOLE: "Antiparasitic (Fexinidazole)",
  // Antivirals
  ANTIVIRALS: "Antivirals",
  PAXLOVID: "Antivirals (Paxlovid)",
  OSELTAMIVIR_ZANAMIVIR: "Antivirals (oseltamivir, zanamivir)",
  HAART_ART: "Antivirals (HAART/ART)",
  TECOVIRIMAT: "Antivirals (Tecovirimat)",
  ACYCLOVIR: "Antivirals (Acyclovir)",
  DIRECT_ACTING_ANTIVIRALS: "Antivirals (Direct-acting)",
  ACYCLOVIR_VALACYCLOVIR: "Antivirals (Acyclovir/Valacyclovir)",
  GANCICLOVIR: "Antivirals (Ganciclovir)",
  RIBAVIRIN_IMMUNOCOMPROMISED: "Antivirals (Ribavirin, immunocompromised)",
  // Antifungals
  FLUCONAZOLE: "Antifungals (Fluconazole)",
  VORICONAZOLE: "Antifungals (Voriconazole)",
  ITRACONAZOLE: "Antifungals (Itraconazole)",
  // Antiparasitic
  ARTEMISININ_BASED: "Antiparasitic (Artemisinin-based therapy)",
  PENTAVALENT_ANTIMONIALS: "Antiparasitic (Pentavalent antimonials)",
  BENZNIDAZOLE_NIFURTIMOX: "Antiparasitic (Benznidazole/Nifurtimox)",
  PRAZIQUANTEL: "Antiparasitic (Praziquantel)",
  DIETHYLCARBAMAZINE: "Antiparasitic (Diethylcarbamazine)",
  METRONIDAZOLE_LUMINAL_AGENT: "Antiparasitic (Metronidazole + luminal agent)",
  // Antimicrobial
  NITAZOXANIDE: "Antimicrobial (Nitazoxanide)",
  // Supportive Care & Symptomatic Treatment
  SUPPORTIVE_CARE: "Supportive care",
  SUPPORTIVE_CARE_MONOCLONAL: "Supportive care, monoclonal antibodies",
  SUPPORTIVE_CARE_NSAIDS: "Supportive care (NSAIDs, analgesics)",
  ORAL_REHYDRATION: "Supportive care (Oral rehydration)",
  FLUID_REPLACEMENT: "Supportive care (Fluid replacement)",
  // Other
  RIPE_THERAPY: "RIPE therapy",
  PEGYLATED_INTERFERON: "Pegylated interferon",
  HPV_LESION_TREATMENT: "No treatment for the virus; lesions treated with cryotherapy/podophyllotoxin",
  NO_CURE: "No available cure after symptoms appear"
};

export const diseases = [
  {
    name: "Syphilis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 10,
    incubationMax: 90,
    treatment: TREATMENTS.PENICILLIN_G,
    vector: VECTORS.DIRECT_CONTACT,
    trivia: "Treponema pallidum still can't be grown on artificial lab media — its genome is so degenerate, stripped of most metabolic genes, that it's obligately dependent on the host. That's why diagnosis relies on serology and dark-field microscopy rather than culture. The Jarisch-Herxheimer reaction, where patients feel dramatically worse hours after their first penicillin dose, comes from the mass lysis of spirochetes dumping lipoproteins into the bloodstream.",
    smallHint: "Spirochete causing a painless chancre, then the systemic 'great imitator' stages",
    bigHint: "Classic STI with a painless sore, curable with penicillin"
  },
  {
    name: "HPV",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 30,
    incubationMax: 240,
    treatment: TREATMENTS.HPV_LESION_TREATMENT,
    vector: VECTORS.DIRECT_CONTACT,
    trivia: "The most famous cell line in all of biology — HeLa, the first immortal human cells, used in millions of experiments including the polio vaccine — came from Henrietta Lacks's cervical cancer, which was driven by HPV-18. The viral DNA had integrated right next to the c-myc oncogene, and the E6/E7 proteins switched telomerase back on, which is a large part of why those cells never stop dividing to this day.",
    smallHint: "Papillomavirus with koilocytes; oncogenic types 16/18 drive cervical dysplasia",
    bigHint: "STI causing warts and cervical cancer, prevented by the Gardasil vaccine"
  },
  {
    name: "Ringworm (Tinea)",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.FUNGUS,
    incubationMin: 4,
    incubationMax: 14,
    treatment: TREATMENTS.TOPICAL_ANTIFUNGALS,
    vector: VECTORS.DIRECT_CONTACT,
    trivia: "Dermatophytes digest keratin with secreted keratinases and feed only on the dead, outermost layer of skin — they never invade living tissue, which is why the infection is so superficial. The classic ring shape comes from the fungus growing outward at the edges while the immune response clears the older center behind it, so the 'active' infection is always the advancing rim.",
    smallHint: "Dermatophytes digesting keratin; annular plaques with central clearing, hyphae on KOH",
    bigHint: "Itchy ring-shaped skin fungus (athlete's foot)"
  },
  {
    name: "Amebiasis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.PROTOZOA,
    incubationMin: 7,
    incubationMax: 28,
    treatment: TREATMENTS.METRONIDAZOLE_LUMINAL_AGENT,
    vector: VECTORS.FECAL_ORAL,
    trivia: "Entamoeba histolytica kills host cells by trogocytosis — it literally bites off and swallows fragments of the living cell membrane, nibbling the cell to death rather than engulfing it whole. This 'nibbling' ability is exactly what separates the pathogenic E. histolytica from the morphologically identical, harmless E. dispar, which looks the same under the microscope but can't do it.",
    smallHint: "Entamoeba histolytica causing flask-shaped colonic ulcers",
    bigHint: "Amoeba from dirty food or water causing bloody diarrhea that can abscess the liver"
  },
  {
    name: "Tapeworm (Taeniasis)",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.PARASITE,
    incubationMin: 56,
    incubationMax: 84,
    treatment: TREATMENTS.PRAZIQUANTEL,
    vector: VECTORS.UNDERCOOKED_MEAT,
    trivia: "Neurocysticercosis cysts survive in the brain for years by molecular camouflage: the larva coats itself in host-derived proteins and secretes molecules that mimic the host's own immune signals, so the immune system reads it as 'self.' The seizures often start only when the larva finally dies — its cloak breaks down, the immune system suddenly sees the intruder, and the inflammation that follows is what triggers the epilepsy.",
    smallHint: "Intestinal cestode shedding proglottids; ingested eggs cause neurocysticercosis",
    bigHint: "Tapeworm from undercooked meat"
  },
  {
    name: "Botulism",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 0,
    incubationMax: 3,
    treatment: TREATMENTS.BOTULINUM_ANTITOXIN,
    vector: VECTORS.CONTAMINATED_FOOD,
    trivia: "Botulinum toxin cleaves SNARE proteins (SNAP-25) at the neuromuscular junction, blocking acetylcholine release → descending FLACCID paralysis. It's the exact mirror image of tetanus: tetanospasmin also cleaves SNARE proteins, but inside the spinal cord's inhibitory neurons (shutting off GABA/glycine) → SPASTIC paralysis. Same Clostridium genus, same class of mechanism, opposite clinical outcome — one relaxes you to death, the other locks you rigid.",
    smallHint: "Toxin-mediated descending flaccid paralysis, cleaves SNAP-25 at the neuromuscular junction",
    bigHint: "Descending paralysis after improperly canned food or a contaminated wound; the toxin behind Botox"
  },
  {
    name: "African Sleeping Sickness",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.PROTOZOA,
    incubationMin: 7,
    incubationMax: 21,
    treatment: TREATMENTS.FEXINIDAZOLE,
    vector: VECTORS.TSETSE_FLY,
    trivia: "Trypanosoma brucei uses antigenic variation: it constantly swaps its surface coat glycoprotein (VSG) from a repertoire of over a thousand genes, so by the time your antibodies catch up to one version, the parasite is already wearing the next — producing the characteristic waves of parasitemia and defeating every vaccine attempt. It dedicates roughly 10% of its entire genome just to this wardrobe of disguises, a staggering evolutionary investment in one trick.",
    smallHint: "Trypanosoma brucei with VSG antigenic variation, Winterbottom's sign, CNS invasion",
    bigHint: "Tropical disease that flips day and night, then ends in fatal coma"
  },
  {
    name: "Legionellosis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 2,
    incubationMax: 10,
    treatment: TREATMENTS.LEVOFLOXACIN_AZITHROMYCIN,
    vector: `${VECTORS.WATERBORNE}/${VECTORS.AIRBORNE}`,
    trivia: "Legionella multiplies inside free-living amoebae in water systems using the same machinery it later uses to hijack human alveolar macrophages — it essentially 'practises' on protozoa for millions of years before ever meeting a person. A bacterium with no need for humans ends up thriving inside the very immune cells sent to destroy it.",
    smallHint: "Atypical pneumonia with hyponatremia and GI symptoms, grows on BCYE agar",
    bigHint: "Pneumonia from air-conditioning and water systems, named after a 1976 convention"
  },
  {
    name: "Naegleria (PAM)",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.PROTOZOA,
    incubationMin: 1,
    incubationMax: 9,
    treatment: TREATMENTS.NO_CURE,
    vector: VECTORS.WATERBORNE,
    trivia: "Naegleria enters through the cribriform plate of the ethmoid bone, travelling up the olfactory nerves straight into the brain, and feeds on neurons using suction structures called amoebastomes that physically tear pieces off the cells. Primary amoebic meningoencephalitis is ~97% fatal, and the handful of survivors were almost all treated with miltefosine plus deliberately induced hypothermia.",
    smallHint: "Free-living protozoan causing rapidly fatal primary meningoencephalitis",
    bigHint: "The infamous 'brain-eating amoeba'"
  },
  {
    name: "COVID-19",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 2,
    incubationMax: 14,
    treatment: TREATMENTS.PAXLOVID,
    vector: VECTORS.DROPLET,
    trivia: "Llamas helped science fight COVID - Antibodies from llamas have a unique structure that scientists studied for potential COVID treatments.",
    smallHint: "Respiratory illness with loss of taste/smell",
    bigHint: "Recent pandemic that changed the world"
  },
  {
    name: "Malaria",
    vaccine: VACCINE_AVAILABILITY.LIMITED,
    etiology: ETIOLOGY.PROTOZOA,
    incubationMin: 7,
    incubationMax: 30,
    treatment: TREATMENTS.ARTEMISININ_BASED,
    vector: VECTORS.MOSQUITO,
    trivia: "Some parasites enter a quiescent state when exposed to artemisinin, then 'wake up' days later — a key reason resistance is emerging.",
    smallHint: "Plasmodium parasites causing cyclic fever and chills",
    bigHint: "Mosquito-borne tropical disease causing fever"
  },
  {
    name: "Tuberculosis",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 14,
    incubationMax: 84,
    treatment: TREATMENTS.RIPE_THERAPY,
    vector: VECTORS.AIRBORNE,
    trivia: "TB divides only once every ~18-24 hours, compared to minutes for many bacteria — which is why cultures can take 6-8 weeks to turn positive.",
    smallHint: "Atypical pneumonia from pathogens that are difficult to culture",
    bigHint: "Chronic coughing disease, historically called consumption"
  },
  {
    name: "HIV/AIDS",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 14,
    incubationMax: 28,
    treatment: TREATMENTS.HAART_ART,
    vector: `${VECTORS.BLOOD}/${VECTORS.BODY_FLUIDS}`,
    trivia: "Timothy Ray Brown, the 'Berlin Patient,' became the first person cured of HIV after receiving a bone marrow transplant from a donor with a rare CCR5-Δ32 mutation (which makes immune cells resistant to HIV). The transplant was originally to treat his leukemia, but it eradicated the virus as well.",
    smallHint: "Retrovirus causing CD4+ T cell depletion and opportunistic infections",
    bigHint: "Severe, chronic immune system disease that was epidemic in the 1980s"
  },
  {
    name: "Influenza",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 1,
    incubationMax: 4,
    treatment: TREATMENTS.OSELTAMIVIR_ZANAMIVIR,
    vector: VECTORS.DROPLET,
    trivia: "Pig respiratory tracts have receptors for both avian and human influenza, allowing them to be infected by multiple strains at once. When this happens, the viruses can undergo genetic 'reassortment,' swapping gene segments to create entirely new hybrid strains — a process behind pandemics like H1N1 in 2009.",
    smallHint: "Orthomyxovirus causing sudden onset fever, myalgia, and respiratory symptoms",
    bigHint: "Common seasonal illness requiring yearly vaccination"
  },
  {
    name: "Dengue",
    vaccine: VACCINE_AVAILABILITY.LIMITED,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 4,
    incubationMax: 10,
    treatment: TREATMENTS.SUPPORTIVE_CARE,
    vector: VECTORS.MOSQUITO,
    trivia: "The dengue vaccine (like Dengvaxia) is only recommended for people who've already had dengue because in those never infected, it can mimic a first infection and increase the risk of severe dengue if they catch it later. This happens due to a weird immune quirk called antibody-dependent enhancement (ADE).",
    smallHint: "Aedes aegypti-transmitted flavivirus with hemorrhagic complications",
    bigHint: "Tropical mosquito disease causing severe body pain"
  },
  {
    name: "Cholera",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 1,
    incubationMax: 5,
    treatment: TREATMENTS.ORAL_REHYDRATION,
    vector: VECTORS.WATERBORNE,
    trivia: "Antibiotics can transiently worsen cholera symptoms by causing bacterial lysis and sudden cholera toxin release, which is why aggressive fluid resuscitation must precede antimicrobial therapy in treatment protocols.",
    smallHint: "Comma-shaped, causing massive watery diarrhea and dehydration",
    bigHint: "Severe diarrheal disease from contaminated water, common in areas with poor sanitation"
  },
  {
    name: "Rabies",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 30,
    incubationMax: 90,
    treatment: TREATMENTS.NO_CURE,
    vector: VECTORS.ANIMAL_BITE,
    trivia: "Despite rare survivors from the Milwaukee Protocol (ketamine coma + antivirals), rabies is still considered ~100% fatal post-symptoms due to irreversible CNS damage—most 'miracle' cases involved bat strains or partial immunity. Only ~5 of 36 attempted cases survived.",
    smallHint: "Rhabdovirus causing encephalitis with hydrophobia and aerophobia",
    bigHint: "Fatal animal bite disease causing fear of water"
  },
  {
    name: "Tetanus",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 3,
    incubationMax: 21,
    treatment: TREATMENTS.IMMUNOGLOBULIN_ANTIBIOTICS,
    vector: VECTORS.WOUND_CONTAMINATION,
    trivia: "Tetanus isn't caused by rust—Clostridium tetani spores live in soil/dust. Rust just often accompanies dirty wounds.",
    smallHint: "Neurotoxin causing classic triad of trismus, risus sardonicus and opisthotonus",
    bigHint: "Causes lockjaw from dirty wounds"
  },
  {
    name: "Measles",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 10,
    incubationMax: 14,
    treatment: TREATMENTS.SUPPORTIVE_CARE,
    vector: VECTORS.AIRBORNE,
    trivia: "Measles is the world's most contagious human virus (R₀ 12-18), spreading via airborne 'viral smoke' that lingers for hours. It also causes 'immune amnesia,' deleting 20-70% of existing antibodies for years—making survivors vulnerable to other deadly infections. While Vitamin A is protocol for severe cases, it only helps malnourished kids (it corrects deficiency-related immune failure, not the virus itself—despite popular 'natural remedy' myths).",
    smallHint: "Paramyxovirus with Koplik spots and maculopapular rash",
    bigHint: "Childhood disease with characteristic red rash"
  },
  {
    name: "Hepatitis B",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 30,
    incubationMax: 180,
    treatment: TREATMENTS.ANTIVIRALS,
    vector: `${VECTORS.BLOOD}/${VECTORS.BODY_FLUIDS}`,
    trivia: "Hepatitis B virus (HBV), a partially double-stranded DNA virus, utilizes reverse transcriptase to replicate via an RNA intermediate—similar to retroviruses. However, its persistence is mediated by covalently closed circular DNA (cccDNA), which integrates into hepatocyte nuclei and serves as a stable transcriptional template resistant to current antiviral therapies.",
    smallHint: "Hepadnavirus causing chronic hepatitis and cirrhosis risk",
    bigHint: "Liver infection transmitted through blood and sexual contacts"
  },
  {
    name: "Lyme Disease",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 3,
    incubationMax: 30,
    treatment: TREATMENTS.DOXYCYCLINE,
    vector: VECTORS.TICK,
    trivia: "The first-generation Lyme vaccine (LYMErix, 1998) was discontinued due to litigation despite 78% efficacy. Current candidates include VLA15 (recombinant OspA protein, Phase 3) and mRNA-based vaccines (Pfizer/Valneva). Novel approaches target vector transmission: canine and experimental human vaccines induce antibodies that neutralize Borrelia burgdorferi within the tick midgut during blood feeding, potentially blocking transmission at the arthropod level.",
    smallHint: "Spirochete with erythema migrans",
    bigHint: "Tick-borne disease with bull's-eye rash"
  },
  {
    name: "Ebola",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 2,
    incubationMax: 21,
    treatment: TREATMENTS.SUPPORTIVE_CARE_MONOCLONAL,
    vector: VECTORS.BODY_FLUIDS,
    trivia: "Ebola's terrifying infectiousness (ID₅₀ = 1-10 particles, vs HIV's ~1,000) drives explosive nosocomial spread—yet the 97.5%-effective rVSV-ZEBOV vaccine requires Arctic -60°C storage, creating deadly logistic hurdles in outbreak zones.",
    smallHint: "Filovirus causing hemorrhagic fever with 50-90% mortality",
    bigHint: "Deadly hemorrhagic fever from West Africa with outbreaks in 2010s"
  },
  {
    name: "Yellow Fever",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 3,
    incubationMax: 6,
    treatment: TREATMENTS.SUPPORTIVE_CARE,
    vector: VECTORS.MOSQUITO,
    trivia: "The virus targets the dorsal motor nucleus of the vagus nerve, causing gastric stasis (hence severe vomiting) and autonomic dysfunction—manifesting as Faget's sign: the paradoxical bradycardia (pulse <90 bpm) despite high fever, a hallmark of yellow fever's brainstem invasion.",
    smallHint: "Flavivirus with hepatic necrosis and black vomit in tropics",
    bigHint: "Mosquito disease causing jaundice"
  },
  {
    name: "Candidiasis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.FUNGUS,
    incubationMin: 1,
    incubationMax: 14,
    treatment: TREATMENTS.FLUCONAZOLE,
    vector: `${VECTORS.ENDOGENOUS}/${VECTORS.DIRECT_CONTACT}`,
    trivia: "Patients with complement deficiencies have increased Candida colonization but often less severe invasive disease. Without complement-mediated inflammation, tissue damage is reduced, but the lack of fungal clearance leads to chronic, smoldering infections.",
    smallHint: "Opportunistic fungal infection with white plaques or vaginal discharge",
    bigHint: "Common yeast infection in mouth or genitals"
  },
  {
    name: "Aspergillosis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.FUNGUS,
    incubationMin: 1,
    incubationMax: 14,
    treatment: TREATMENTS.VORICONAZOLE,
    vector: VECTORS.AIRBORNE_SPORES,
    trivia: "In Allergic Bronchopulmonary Aspergillosis, steroids reduce inflammation but suppress antifungal immunity, allowing continued fungal growth despite symptom improvement. Iron chelation can help by starving Aspergillus, but excessive chelation impairs the already steroid-weakened neutrophil response. This creates a treatment paradox where both anti-inflammatory therapy and iron restriction can simultaneously help and harm the patient.",
    smallHint: "Opportunistic mold causing invasive pulmonary disease and ABPA",
    bigHint: "Lung fungal infection in immunocompromised patients"
  },
  {
    name: "Zika",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 3,
    incubationMax: 14,
    treatment: TREATMENTS.SUPPORTIVE_CARE,
    vector: VECTORS.MOSQUITO,
    trivia: "Prior dengue infection creates antibodies that enhance Zika cell entry through ADE, increasing viral loads during pregnancy. This enhanced replication is particularly devastating when it occurs during the critical 10-20 week neurotropism window, leading to more severe microcephaly in dengue-endemic regions.",
    smallHint: "Flavivirus linked to microcephaly and Guillain-Barré syndrome",
    bigHint: "Mosquito virus causing birth defects"
  },
  {
    name: "Typhoid",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 6,
    incubationMax: 30,
    treatment: TREATMENTS.CEFTRIAXONE_AZITHROMYCIN,
    vector: VECTORS.FECAL_ORAL,
    trivia: "S. typhi specifically damages intestinal brush border lactase enzymes through direct enzymatic cleavage. This creates permanent lactose intolerance in up to 30% of survivors. In patients with sickle cell disease, S. typhi has a unique tropism for bone marrow in the femur and humerus.",
    smallHint: "Rose spots, step-ladder fever pattern",
    bigHint: "Bacterial infection from contaminated food/water causing weeks of high fever and abdominal pain"
  },
  {
    name: "Whooping Cough",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 5,
    incubationMax: 10,
    treatment: TREATMENTS.ANTIBIOTICS_MACROLIDES,
    vector: VECTORS.DROPLET,
    trivia: "Pertussis causes extreme lymphocytosis (>50,000/μL) not through systemic infection but because pertussis toxin blocks lymphocyte trafficking signals. Lymphocytes accumulate in blood because they can't migrate to tissues properly, creating a \"traffic jam\" effect.",
    smallHint: "Bordetella pertussis causing paroxysmal cough with inspiratory whoop",
    bigHint: "Childhood disease with characteristic violent cough"
  },
  {
    name: "Polio",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 7,
    incubationMax: 14,
    treatment: TREATMENTS.SUPPORTIVE_CARE,
    vector: VECTORS.FECAL_ORAL,
    trivia: "Post-polio syndrome occurs decades later because surviving motor neurons become overworked. Each remaining neuron sprouts extra branches to innervate orphaned muscle fibers, creating \"super motor units\" that eventually burn out from metabolic exhaustion after 30-40 years of overuse.",
    smallHint: "Flaccid paralysis and iron lung dependence",
    bigHint: "Paralytic disease nearly eradicated by vaccination"
  },
  {
    name: "Bacterial meningitis",
    vaccine: VACCINE_AVAILABILITY.LIMITED,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 1,
    incubationMax: 10,
    treatment: TREATMENTS.IV_ANTIBIOTICS_STEROIDS,
    vector: VECTORS.RESPIRATORY_DROPLETS,
    trivia: "Steroids must be given before or with the first antibiotic dose to be effective because they specifically block the inflammatory cascade triggered by bacterial lysis. If given even 2-4 hours after antibiotics, steroids may actually worsen outcomes by suppressing beneficial immune responses while failing to prevent initial damage.",
    smallHint: "Infection with CSF pleocytosis and Kernig's sign",
    bigHint: "Brain infection causing severe headache and stiff neck"
  },
  {
    name: "Anthrax",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 1,
    incubationMax: 7,
    treatment: TREATMENTS.CIPROFLOXACIN_DOXYCYCLINE,
    vector: `${VECTORS.AIRBORNE_SPORES}/${VECTORS.DIRECT_CONTACT}`,
    trivia: "Bacillus anthracis spores remain dormant until they detect specific environmental cues (CO2, amino acids, nucleosides) that indicate they're inside a mammalian host. This sophisticated chemical sensing ensures spores only germinate in optimal conditions for infection.",
    smallHint: "Spore-forming bacteria with cutaneous eschar and woolsorter's disease",
    bigHint: "Bioweapon causing skin lesions or lung disease"
  },
  {
    name: "Plague",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 1,
    incubationMax: 6,
    treatment: TREATMENTS.STREPTOMYCIN_GENTAMICIN,
    vector: VECTORS.FLEA_BITE,
    trivia: "Y. pestis employs a sophisticated dual-elimination strategy - producing murine toxin to kill competing rodent hosts while using pesticin bacteriocin to eliminate competing bacterial species. This allows the bacteria to simultaneously manage both its mammalian ecosystem (preserving humans as transmission reservoirs while removing rodent competitors) and its microbial environment (securing exclusive access to host resources by eliminating bacterial rivals).",
    smallHint: "Yersinia pestis causing bubonic lymphadenopathy",
    bigHint: "Medieval 'Black Death' that killed millions"
  },
  {
    name: "Leishmaniasis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.PROTOZOA,
    incubationMin: 14,
    incubationMax: 180,
    treatment: TREATMENTS.PENTAVALENT_ANTIMONIALS,
    vector: VECTORS.SANDFLY,
    trivia: "Leishmaniasis recidivans is characterized by reactivation of latent amastigotes after prolonged clinical quiescence (20-40 years), typically triggered by immunocompromise, physiological stress, or immunosenescence. These dormant parasites persist in tissue macrophages, evading immune surveillance until host immune competence becomes compromised, leading to renewed parasite multiplication and clinical manifestation.",
    smallHint: "Sandfly-transmitted protozoan causing cutaneous ulcers or fatal visceral disease (kala-azar)",
    bigHint: "Parasite causing 'Baghdad boil' - chronic skin ulcers in Middle Eastern regions"
  },
  {
    name: "Chagas Disease",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.PROTOZOA,
    incubationMin: 7,
    incubationMax: 14,
    treatment: TREATMENTS.BENZNIDAZOLE_NIFURTIMOX,
    vector: VECTORS.TRIATOMINE_BUG,
    trivia: "The parasites have an extraordinary ability to hide in plain sight. T. cruzi can remain dormant in cardiac muscle cells for decades, occasionally emerging to cause arrhythmias, heart failure, or sudden cardiac death - often the first sign that someone was infected years earlier.",
    smallHint: "Trypanosoma cruzi causing acute myocarditis progressing to chronic cardiomyopathy decades later",
    bigHint: "Kissing bug' disease from Latin America that silently damages the heart over years"
  },
  {
    name: "Schistosomiasis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.PARASITE,
    incubationMin: 28,
    incubationMax: 42,
    treatment: TREATMENTS.PRAZIQUANTEL,
    vector: VECTORS.FRESHWATER_SNAILS,
    trivia: "Schistosomiasis has an unusual relationship with HIV co-infection. The chronic inflammation caused by schistosome eggs actually increases HIV viral loads and accelerates AIDS progression, while HIV makes schistosomiasis more severe - creating a deadly synergistic effect.",
    smallHint: "Blood fluke causing hematuria and portal hypertension",
    bigHint: "Tropical disease from swimming in infected water"
  },
  {
    name: "Filariasis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.PARASITE,
    incubationMin: 240,
    incubationMax: 365,
    treatment: TREATMENTS.DIETHYLCARBAMAZINE,
    vector: VECTORS.MOSQUITO,
    trivia: "Hydrocele (scrotal swelling) from filariasis can become so massive that men require wheelbarrows to carry their enlarged scrotums. Some cases have been documented weighing over 100 pounds, making basic activities like walking or sitting impossible.",
    smallHint: "Lymphatic obstruction by filarial worms causing elephantiasis",
    bigHint: "Mosquito disease causing massive limb swelling"
  },
  {
    name: "Diphtheria",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 2,
    incubationMax: 5,
    treatment: TREATMENTS.ANTITOXIN_ANTIBIOTICS,
    vector: VECTORS.RESPIRATORY_DROPLETS,
    trivia: "Diphtheria toxin is one of the most potent biological poisons known to science - it's so lethal that a single molecule entering a cell can kill it. The toxin works by shutting down protein synthesis, essentially starving cells to death from the inside out.",
    smallHint: "Bacteria creating pseudomembrane and cardiac toxicity",
    bigHint: "Throat infection with gray membrane, prevented by DPT vaccine"
  },
  {
    name: "Smallpox",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 7,
    incubationMax: 17,
    treatment: TREATMENTS.TECOVIRIMAT,
    vector: VECTORS.DROPLET,
    trivia: "Smallpox is the only human infectious disease completely eradicated from nature, yet it remains \"immortal\" in two maximum-security laboratories (CDC in Atlanta and VECTOR in Russia). The last natural case occurred in Somalia in 1977, but the final death was tragically a Birmingham laboratory accident in 1978 that infected a medical photographer through contaminated ventilation, leading to the laboratory director's suicide from guilt.",
    smallHint: "Variola virus with characteristic pustular rash and high mortality",
    bigHint: "First disease eradicated by vaccination"
  },
  {
    name: "Chickenpox",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 10,
    incubationMax: 21,
    treatment: TREATMENTS.ACYCLOVIR,
    vector: VECTORS.DROPLET,
    trivia: "Chickenpox has nothing to do with chickens - the name likely comes from the Old English \"gican,\" meaning \"to itch,\" or because the blisters resemble chickpeas. The virus is actually a herpes virus (varicella-zoster virus) that becomes your lifelong, unwelcome tenant.",
    smallHint: "Varicella-zoster virus with vesicular rash and later shingles risk",
    bigHint: "Childhood disease with itchy blisters all over body"
  },
  {
    name: "Mumps",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 16,
    incubationMax: 18,
    treatment: TREATMENTS.SUPPORTIVE_CARE,
    vector: VECTORS.RESPIRATORY_DROPLETS,
    trivia: "The virus has a sinister preference for glandular tissue throughout the body. While everyone knows about salivary gland swelling, mumps can also attack pancreas, ovaries, breasts, and thyroid - essentially any glandular tissue becomes a potential target for this opportunistic invader.",
    smallHint: "Paramyxovirus causing parotitis and potential orchitis in males",
    bigHint: "Childhood disease causing swollen cheeks"
  },
  {
    name: "Rubella",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 12,
    incubationMax: 23,
    treatment: TREATMENTS.SUPPORTIVE_CARE,
    vector: VECTORS.RESPIRATORY_DROPLETS,
    trivia: "The virus has a peculiar \"oncogenic paradox\" - while rubella infection during pregnancy causes birth defects, some studies suggest childhood rubella infection may actually provide protection against certain cancers later in life, particularly Hodgkin's lymphoma. The virus essentially trades short-term risk for long-term benefit.",
    smallHint: "Togavirus causing congenital rubella syndrome with TORCH infections",
    bigHint: "Mild childhood rash disease dangerous in pregnancy"
  },
  {
    name: "Hepatitis A",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 15,
    incubationMax: 50,
    treatment: TREATMENTS.SUPPORTIVE_CARE,
    vector: VECTORS.FECAL_ORAL,
    trivia: "Hepatitis A demonstrates \"fecal-oral stealth transmission\" with as few as 10 viral particles causing infection, allowing a single infected food handler to contaminate entire restaurants. The virus creates a cruel paradox where patients are most contagious during the 2 weeks before symptoms appear, spreading disease while feeling perfectly healthy and going about normal activities.",
    smallHint: "Picornavirus causing acute hepatitis without chronic progression",
    bigHint: "Liver infection from contaminated food or water"
  },
  {
    name: "Hepatitis C",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 14,
    incubationMax: 180,
    treatment: TREATMENTS.DIRECT_ACTING_ANTIVIRALS,
    vector: `${VECTORS.BLOOD}/${VECTORS.BODY_FLUIDS}`,
    trivia: "The direct-acting antivirals (DAAs) that cure hepatitis C work so well they've created a new medical phenomenon: \"SVR\" or sustained virologic response, where virus becomes completely undetectable. HCV became the first curable chronic viral infection in human history.",
    smallHint: "Flavivirus with high chronicity rate, associated with IV drug use",
    bigHint: "Blood-borne liver infection often becoming chronic"
  },
  {
    name: "Herpes Simplex",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 2,
    incubationMax: 12,
    treatment: TREATMENTS.ACYCLOVIR_VALACYCLOVIR,
    vector: VECTORS.DIRECT_CONTACT,
    trivia: "The most shocking fact is that herpes may actually be neuroprotective in some contexts. Emerging research suggests HSV-1 infection might provide protection against Alzheimer's disease and other neurodegenerative conditions, creating the paradox that a brain-infecting virus might actually protect brain function in some individuals.",
    smallHint: "DNA virus with vesicular lesions and lifelong latency in ganglia",
    bigHint: "Common virus causing cold sores or genital lesions"
  },
  {
    name: "Cytomegalovirus",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 21,
    incubationMax: 84,
    treatment: TREATMENTS.GANCICLOVIR,
    vector: `${VECTORS.SALIVA}/${VECTORS.BODY_FLUIDS}`,
    trivia: "There's a phenomenon called \"CMV retinitis\" in immunocompromised patients where the virus literally eats away at the retina, causing progressive blindness that advances in a characteristic \"brushfire\" pattern. Before effective HIV treatment, CMV retinitis was called \"AIDS retinopathy.\"",
    smallHint: "Causes infectious mononucleosis syndrome alongside EBV, particularly in adults",
    bigHint: "Kissing disease' affecting adults rather than teenagers, often goes undiagnosed"
  },
  {
    name: "Epstein-Barr Virus",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 28,
    incubationMax: 42,
    treatment: TREATMENTS.SUPPORTIVE_CARE,
    vector: VECTORS.SALIVA,
    trivia: "EBV demonstrates distinct geographic oncogenic tropism, with identical viral strains exhibiting differential malignant transformation patterns: Burkitt lymphoma predominates in equatorial Africa, nasopharyngeal carcinoma clusters in Southern China, while Hodgkin lymphoma maintains global distribution, suggesting region-specific cofactors modulate viral oncogenesis through undefined genetic or environmental mechanisms.",
    smallHint: "Herpesvirus causing infectious mononucleosis (along with CMV) with atypical lymphocytes",
    bigHint: "Virus causing 'mono' or kissing disease in teenagers"
  },
  {
    name: "Hand-Foot-Mouth Disease",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 3,
    incubationMax: 7,
    treatment: TREATMENTS.SUPPORTIVE_CARE,
    vector: `${VECTORS.FECAL_ORAL}/${VECTORS.RESPIRATORY_DROPLETS}`,
    trivia: "There's a phenomenon called \"onychomadesis\" where children's fingernails and toenails fall off 4-6 weeks after HFMD infection. Parents panic thinking their child has a serious nail disease, not realizing it's a delayed consequence of a seemingly mild viral illness they forgot about.",
    smallHint: "Coxsackievirus causing vesicular lesions in young children",
    bigHint: "Childhood disease with blisters on hands, feet, and mouth"
  },
  {
    name: "Norovirus",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 0,
    incubationMax: 2,
    treatment: TREATMENTS.FLUID_REPLACEMENT,
    vector: VECTORS.CONTAMINATED_FOOD,
    trivia: "Norovirus causes explosive vomiting by directly stimulating the vagus nerve, triggering powerful stomach contractions that can launch vomit over 20 feet.",
    smallHint: "Calicivirus causing explosive gastroenteritis outbreaks",
    bigHint: "Cruise ship stomach bug causing vomiting and diarrhea"
  },
  {
    name: "Rotavirus",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 1,
    incubationMax: 3,
    treatment: TREATMENTS.ORAL_REHYDRATION,
    vector: VECTORS.FECAL_ORAL,
    trivia: "Rotavirus demonstrates \"lactase destruction\" - the infection strips away lactase-producing cells from the intestinal villi, causing temporary lactose intolerance that can persist for weeks after the acute illness resolves. Children who normally tolerate milk suddenly become lactose intolerant during recovery.",
    smallHint: "DsRNA virus causing dehydrating gastroenteritis in infants",
    bigHint: "Leading cause of severe diarrhea in babies"
  },
  {
    name: "Giardiasis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.PROTOZOA,
    incubationMin: 7,
    incubationMax: 21,
    treatment: TREATMENTS.METRONIDAZOLE,
    vector: VECTORS.CONTAMINATED_WATER,
    trivia: "Giardia causes severe duodenal villous atrophy that mimics celiac disease on biopsy and destroys lactase-producing cells, leading to misdiagnosis with celiac disease and acquired lactose intolerance that can be permanent even after parasitic clearance.",
    smallHint: "Flagellated protozoa causing malabsorption and steatorrhea",
    bigHint: "Traveler's diarrhea from contaminated water"
  },
  {
    name: "Cryptosporidiosis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.PROTOZOA,
    incubationMin: 2,
    incubationMax: 10,
    treatment: TREATMENTS.NITAZOXANIDE,
    vector: `${VECTORS.CONTAMINATED_WATER}/${VECTORS.CONTAMINATED_FOOD}`,
    trivia: "Cryptosporidium demonstrates remarkable \"intracellular-extracellular\" parasitism by invading intestinal epithelial cells yet remaining enclosed in parasitophorous vacuoles outside the cytoplasm, essentially mastering simultaneous cellular invasion and immune evasion. This unique positioning, combined with exceptional chlorine resistance allowing oocyst survival in treated water for days, transforms properly disinfected swimming pools and municipal supplies into vectors for massive waterborne outbreaks.",
    smallHint: "Acid-fast oocysts causing watery diarrhea, especially in AIDS",
    bigHint: "Swimming pool diarrheal disease resistant to chlorine"
  },
  {
    name: "Toxoplasmosis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.PROTOZOA,
    incubationMin: 5,
    incubationMax: 23,
    treatment: TREATMENTS.SULFADIAZINE_PYRIMETHAMINE,
    vector: VECTORS.CAT_FECES_UNDERCOOKED_MEAT,
    trivia: "Toxoplasma gondii is a \"mind control parasite\" that literally manipulates mammalian behavior to complete its life cycle. Infected rodents lose their fear of cats and are actually attracted to cat urine, essentially turning prey animals into willing victims through neurochemical manipulation.",
    smallHint: "Obligate intracellular protozoa causing chorioretinitis and encephalitis",
    bigHint: "Cat parasite dangerous in pregnancy, causes brain cysts"
  },
  {
    name: "Babesiosis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.PROTOZOA,
    incubationMin: 7,
    incubationMax: 63,
    treatment: TREATMENTS.ATOVAQUONE_AZITHROMYCIN,
    vector: VECTORS.TICK,
    trivia: "The parasite demonstrates \"red blood cell preference\" with species-specific tropism - Babesia microti prefers younger red blood cells while B. divergens attacks all RBCs indiscriminately. This selectivity affects disease severity and explains why B. divergens causes more rapid, life-threatening hemolysis.",
    smallHint: "Intraerythrocytic protozoa causing hemolytic anemia",
    bigHint: "Tick disease resembling malaria in blood smears"
  },
  {
    name: "Leptospirosis",
    vaccine: VACCINE_AVAILABILITY.LIMITED,
    etiology: ETIOLOGY.BACTERIA,
    incubationMin: 2,
    incubationMax: 30,
    treatment: TREATMENTS.PENICILLIN_DOXYCYCLINE,
    vector: `${VECTORS.CONTAMINATED_WATER}/${VECTORS.ANIMAL_URINE}`,
    trivia: "Leptospirosis can cause \"aseptic meningitis\" that's clinically indistinguishable from viral meningitis, but here's the twist - the bacteria are often absent from CSF despite causing meningeal inflammation. It's bacterial meningitis without detectable bacteria, making diagnosis nearly impossible without serologic testing.",
    smallHint: "Spirochete causing Weil's disease with renal and hepatic involvement",
    bigHint: "Disease from rat-contaminated water causing jaundice"
  },
  {
    name: "Histoplasmosis",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.FUNGUS,
    incubationMin: 3,
    incubationMax: 17,
    treatment: TREATMENTS.ITRACONAZOLE,
    vector: VECTORS.SOIL_BIRD_DROPPINGS,
    trivia: "Histoplasmosis demonstrates \"geographic fungal clustering\" with Histoplasma capsulatum thriving in nitrogen-rich soils of the Ohio and Mississippi River valleys. The fungus has a peculiar affinity for bat and bird guano, making caves, chicken coops, and demolition sites potential \"spore bombs\" that can infect entire communities when disturbed.",
    smallHint: "Dimorphic fungus causing pulmonary infection in endemic areas",
    bigHint: "Cave disease from bird droppings in river valleys"
  },
  {
    name: "Hepatitis D",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 21,
    incubationMax: 140,
    treatment: TREATMENTS.PEGYLATED_INTERFERON,
    vector: `${VECTORS.BLOOD}/${VECTORS.BODY_FLUIDS}`,
    trivia: "HDV has the smallest genome of any known human pathogen - only 1,700 nucleotides compared to hepatitis B's 3,200 or hepatitis C's 9,600. This tiny RNA virus is essentially the minimalist masterpiece of viral evolution, stripped down to only the most essential genetic elements needed for replication.",
    smallHint: "Satellite RNA virus requiring another helper functions for replication",
    bigHint: "Incomplete virus that only infects with hepatitis B"
  },
  {
    name: "Hepatitis E",
    vaccine: VACCINE_AVAILABILITY.LIMITED,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 14,
    incubationMax: 70,
    treatment: TREATMENTS.RIBAVIRIN_IMMUNOCOMPROMISED,
    vector: `${VECTORS.FECAL_ORAL}/${VECTORS.CONTAMINATED_WATER}/${VECTORS.UNDERCOOKED_MEAT}`,
    trivia: "Hepatitis E demonstrates \"genotype-specific pathogenicity\" - genotype 1 and 2 cause epidemic disease in humans, genotype 3 and 4 are zoonotic and cause chronic infection in immunocompromised hosts, while newer genotypes are still being discovered in various animals.",
    smallHint: "RNA virus causing acute hepatitis, severe in pregnancy with 20-30% maternal mortality",
    bigHint: "From contaminated water or undercooked pork, usually undiagnosed, second least common hepatitis virus after HDV"
  },
  {
    name: "Chikungunya",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 3,
    incubationMax: 7,
    treatment: TREATMENTS.SUPPORTIVE_CARE_NSAIDS,
    vector: VECTORS.MOSQUITO,
    trivia: "The virus exhibits \"co-circulation complexity\" with dengue and Zika in the same geographic regions, transmitted by identical mosquito vectors. Patients can be co-infected with multiple arboviruses simultaneously, creating diagnostic nightmares and unpredictable clinical syndromes.",
    smallHint: "Alphavirus causing severe joint pain and arthritis that can persist for months",
    bigHint: "Mosquito disease with debilitating joint pain, name means \"to walk bent over\""
  },
  {
    name: "Tick-borne encephalitis (TBEV)",
    vaccine: VACCINE_AVAILABILITY.YES,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 7,
    incubationMax: 14,
    treatment: TREATMENTS.SUPPORTIVE_CARE,
    vector: VECTORS.TICK,
    trivia: "Unlike other tick-borne diseases that need hours of attachment, TBEV transmission can occur within minutes to a few hours of tick attachment.",
    smallHint: "Flavivirus causing biphasic illness with potential neurological complications",
    bigHint: "Tick-transmitted disease with characteristic two-phase fever pattern and encephalitis risk"
  },
  {
    name: "Rhinovirus",
    vaccine: VACCINE_AVAILABILITY.NO,
    etiology: ETIOLOGY.VIRUS,
    incubationMin: 1,
    incubationMax: 3,
    treatment: TREATMENTS.SUPPORTIVE_CARE,
    vector: `${VECTORS.RESPIRATORY_DROPLETS}/${VECTORS.DIRECT_CONTACT}`,
    trivia: "With over 160 different serotypes, rhinoviruses are the ultimate shape-shifters of the viral world, making vaccine development nearly impossible. They prefer the cooler temperatures of the nasal cavity (33°C vs 37°C body temperature) and are responsible for 50% of all common colds. Paradoxically, they rarely cause fever despite being called 'cold' viruses.",
    smallHint: "Picornavirus that prefers cool nasal temperatures",
    bigHint: "Most common cause of the 'common cold'"
  }
];
